/* eslint @typescript-eslint/no-explicit-any: 0 */

import { useEffect } from 'react';

// Slightly dodgy way to work around the current limitation where the search input is outside the modal
// If a user clicks inside the search input, the modal will remain open
// Anywhere else inside document it will be closed
const exceptionsList = [
  'ais-SearchBox-input',
  'ais-SearchBox-submit',
  'ais-SearchBox-reset'
];

const isClickException = (target: any) =>
  typeof target?.closest === 'function' &&
  exceptionsList.some((className) => Boolean(target.closest(`.${className}`)));

export default function useClickOutside(
  ref: any,
  onClick: (event?: any) => void,
  disableClickOutside: boolean
) {
  useEffect(() => {
    const handleClick = (event: any) => {
      if (event.target instanceof Node && !document.contains(event.target)) {
        return;
      }

      const hasUserClickedOutsideModal =
        ref.current &&
        !ref.current.contains(event.target) &&
        !isClickException(event.target);

      if (hasUserClickedOutsideModal && !disableClickOutside) {
        event.stopPropagation();
        onClick(event);
      }
    };

    window.addEventListener('click', handleClick);

    return () => window.removeEventListener('click', handleClick);
  }, [ref, onClick, disableClickOutside]);
}
